import { Platform } from 'react-native';
import parseByDelimiter from '@utils/parseByDelimiter';

export const formatTitle = (title: string | undefined): string => {
  if (!title) return '';
  return parseByDelimiter(title) || '';
};

export const getPlaceholder = (schemaItem: any): string => {
  const explicit =
    schemaItem?.content?.placeHolder ||
    schemaItem?.content?.placeholder ||
    schemaItem?.validation?.placeHolder ||
    schemaItem?.validation?.placeholder;
  if (explicit) return explicit;
  // Web: GetField renders the label above the control — avoid placeholder echoing it.
  if (Platform.OS === 'web' && (schemaItem?.content?.label || schemaItem?.title)) {
    return '';
  }
  return schemaItem?.title ? formatTitle(schemaItem.title) : '';
};

export const getHelpText = (schemaItem: any): string | undefined => {
  return (
    schemaItem?.content?.helpText ||
    schemaItem?.helpText ||
    schemaItem?.validation?.helpText
  );
};

export const genLabel = (item: any): string => {
  if (item.title) return item.title;
  if (item.data?.product_name) return item.data.product_name;
  if (item.label) return formatTitle(item.label);
  if (!item.dataTitle && !item.label) {
    return (item.data?.name + ' ' + item.data?.surname) || 'No Name';
  }
  return item.dataTitle || item.label;
};

/**
 * Stable Appium / WDIO hooks for dynamic GenerateSchemaForm fields.
 * Prefer index (`schema-field-0`) — schema titles change across forms.
 * `nativeID` carries the field key slug for shape-based matching when known.
 */
export const getSchemaFieldA11y = (index: number, schemaItem?: any) => {
  const rawKey = String(schemaItem?.key || schemaItem?.title || schemaItem?.name || 'field');
  const keySlug = rawKey.replace(/[^a-zA-Z0-9_-]+/g, '-').replace(/^-|-$/g, '') || 'field';
  const human =
    schemaItem?.content?.label ||
    schemaItem?.label ||
    formatTitle(schemaItem?.title) ||
    keySlug;
  const byIndex = `schema-field-${index}`;
  return {
    testID: byIndex,
    accessibilityLabel: byIndex,
    accessibilityHint: human,
    accessible: true as const,
    nativeID: `schema-field-key-${keySlug}`,
  };
};
